import { FC } from 'react';
import { SPOUSE, QueryResult } from './query';
import { Question } from 'features/questions/type';
import { useQuery } from '@apollo/client';
import { Form } from './Form';
import { Loading } from 'jbc-front/components/presenters/ui/Loading';

// @ts-ignore
import { useMutation } from 'components/Graphql';

type SpouseProps = {
  question: Question;
};

export const Spouse: FC<SpouseProps> = ({ question }) => {
  const { data, loading } = useQuery<QueryResult>(SPOUSE);
  if (loading || !data) return null;
  const {
    clientSetting: {
      requestImageUploadSettings: { handicap: handicapImageSetting, nonResidentAndStudyAbroad: nonResidentAndStudyAbroadImageSetting }
    }
  } = data;
  return data?.request.profile ? (
    <Form
      question={question}
      profile={data.request.profile}
      handicapImageSetting={handicapImageSetting}
      nonResidentAndStudyAbroadImageSetting={nonResidentAndStudyAbroadImageSetting}
    />
  ) : (
    <Loading />
  );
};
